import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { firebaseEnv } from "../firebase";

type ToolCard = {
  title: string;
  description: string;
  path: string;
};

const TOOLS: ToolCard[] = [
  {
    title: "User Manager",
    description: "Manage account roles and review user activity metadata.",
    path: "/admin/users",
  },
  {
    title: "Survey Master",
    description: "Review surveys by status and transfer survey ownership.",
    path: "/admin/surveys",
  },
  {
    title: "Survey Shape Diagnostics",
    description: "Read-only diagnostics for legacy survey document shape issues.",
    path: "/admin/diagnostics/surveys",
  },
  {
    title: "Manage Test Data",
    description: "Toggle and configure survey/list templates that users can copy.",
    path: "/admin/test-data",
  },
  {
    title: "Rules Reference",
    description: "Permissions matrix and raw Firestore rules snapshot for admin review.",
    path: "/admin/rules",
  },
];

export default function AdminTools() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2 }}>
      <PageHeader
        title="Admin Tools"
        subtitle={`Admin-only utilities (${firebaseEnv} environment)`}
      />

      <Stack spacing={2}>
        {TOOLS.map((tool) => (
          <Paper key={tool.path} variant="outlined" sx={{ p: 2 }}>
            <Stack spacing={1}>
              <Typography variant="h6">{tool.title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {tool.description}
              </Typography>
              <Box>
                <Button variant="contained" onClick={() => navigate(tool.path)}>
                  Open
                </Button>
              </Box>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
